import { useState } from "react";
import { Form, Button, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import courseApi from "../../apis/courseApi";
import "./courseForm.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchCoursesAction } from "../../pages/course/courseAction";

const initialState = {
  title: "",
  courseCode: "",
  courseFee: "",
  location: "",
  classSession: "",
  discount: "",
  commenceDate: "",
  endDate: "",
  status: "inactive", // default status
};

const CourseForm = ({ courseData, setShowEdit }) => {
  const [course, setCourse] = useState(courseData || initialState);
  const { user } = useSelector((state) => state.user);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const params = new URLSearchParams();
  params.set("branch", user?.branch);

  const handleOnChange = (e) => {
    let { name, value, checked, type } = e.target;

    if (name === "status") {
      value = checked ? "active" : "inactive";
    }

    setCourse({
      ...course,
      [name]: value,
    });
  };

  const handleOnSubmit = async (e) => {
    e.preventDefault();

    try {
      if (courseData?._id) {
        const { status, message } = await courseApi.editACourse(course);

        if (status === "success") {
          toast.success(message);
          setShowEdit(false);
          dispatch(fetchCoursesAction(params.toString()));
        } else {
          toast.error(message || "Failed to update course");
        }
      } else {
        const res = await courseApi.addACourse(course);

        if (res._id) {
          toast.success("Course added successfully!");
          navigate("/course");
        } else {
          toast.error("Failed to add course");
        }
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong!");
    }
  };

  return (
    <div>
      <Form
        className={courseData?._id ? "course-edit" : "course-form"}
        onSubmit={handleOnSubmit}
      >
        <Row>
          <Col md={12}>
            <Form.Group className="form-inputs">
              {/* Status Switch */}
              <div className="d-flex align-items-center gap-2 mb-3">
                <Form.Label className="mt-1">
                  <strong>Course Status</strong>
                </Form.Label>
                <Form.Check
                  type="switch"
                  name="status"
                  checked={course?.status === "active"}
                  onChange={handleOnChange}
                />
              </div>

              {/* Title */}
              <div className="form-group mb-3">
                <Form.Label style={{ fontWeight: "bold" }}>Title</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter course title"
                  name="title"
                  onChange={handleOnChange}
                  value={course.title}
                />
              </div>

              {/* Course Code */}
              <div className="form-group mb-3">
                <Form.Label style={{ fontWeight: "bold" }}>
                  Course Code
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter course code"
                  name="courseCode"
                  onChange={handleOnChange}
                  value={course.courseCode}
                />
              </div>

              {/* Course Fee */}
              <div className="form-group mb-3">
                <Form.Label style={{ fontWeight: "bold" }}>
                  Course Fee
                </Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Enter course fee $"
                  name="courseFee"
                  onChange={handleOnChange}
                  value={course.courseFee}
                />
              </div>

              {/* Location */}
              <div className="form-group mb-3">
                <Form.Label style={{ fontWeight: "bold" }}>Location</Form.Label>
                <Form.Select
                  value={course.location}
                  name="location"
                  onChange={handleOnChange}
                >
                  <option value="">-- Select Location --</option>
                  <option value="sydney">Sydney</option>
                  <option value="canberra">Canberra</option>
                </Form.Select>
              </div>

              {/* Class Session */}
              <div className="form-group mb-3">
                <Form.Label style={{ fontWeight: "bold" }}>
                  Class Session
                </Form.Label>
                <Form.Control
                  value={course.classSession}
                  name="classSession"
                  onChange={handleOnChange}
                  placeholder="(Mon-Tue): 9am - 4pm"
                />
              </div>

              {/* Discount */}
              <div className="form-group mb-3">
                <Form.Label style={{ fontWeight: "bold" }}>Discount</Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Enter discount amount $"
                  name="discount"
                  onChange={handleOnChange}
                  value={course.discount}
                />
              </div>

              {/* Commence Date */}
              <div className="form-group mb-3">
                <Form.Label style={{ fontWeight: "bold" }}>
                  Commence Date
                </Form.Label>
                <Form.Control
                  type="date"
                  name="commenceDate"
                  onChange={handleOnChange}
                  value={course.commenceDate?.slice(0, 10) || ""}
                />
              </div>

              {/* End Date */}
              <div className="form-group mb-3">
                <Form.Label style={{ fontWeight: "bold" }}>End Date</Form.Label>
                <Form.Control
                  type="date"
                  name="endDate"
                  onChange={handleOnChange}
                  value={course.endDate ? course.endDate.slice(0, 10) : ""}
                />
              </div>
            </Form.Group>
          </Col>
        </Row>

        <Button type="submit">{courseData?._id ? "Save" : "Add Course"}</Button>
      </Form>
    </div>
  );
};

export default CourseForm;
